import { AppState } from '~system/store/configure-store';

export const selectIsMobileMenuOpen = (state: AppState) =>
  state.mobileMenu.isOpen;
